import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mindmap-legend-contribute-off",
  "use": "icon-mindmap-legend-contribute-off-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-mindmap-legend-contribute-off\">\n<path d=\"M2 12H9M15 12L22 12\" stroke=\"#DFE1E6\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol